module.exports = __webpack_public_path__ + "static/media/social_01.216600cb.jpg";